export default {
  loading: false,
  directory: [],
  modalDirectory: {},
  savedDirectory: false,
  files: '',
  item: false,
  reloadTimeout: false,
  reloadProcessingTimeout: false
}
